
import {  Typography } from "@mui/material";
import ComplexGrid from "../Login/Complex";
import Login from "../Login/Login";
import BasicTabs from "./Howto";
const Slide=()=>{
    return (<>
     <div>
      <ComplexGrid></ComplexGrid>
     </div>
    
    </>);
}
export default Slide;